$.fn.select = function (selector) {
    var $this = $(this);

    var $find_result = $this.find(selector);
    var $filter_result = $this.filter(selector);

    if ($find_result.length > 0 && $filter_result.length > 0) {
        return $filter_result.add($filter_result);
    } else if ($filter_result.length > 0) {
        return $filter_result;
    } else if ($find_result.length > 0) {
        return $find_result;
    } else {
        return $();
    }
};

$.fn.replace = function ($element) {
    if (this.length === 0 || $element.length === 0) {
        return;
    }

    this.each(function () {
        var $fragment = $(document.createDocumentFragment());
        $fragment.append($element);

        if (this.parentNode) {
            this.parentNode.replaceChild($fragment.get(0), this);
        }
    });
};

$.fn.onAnimationEnd = function (selector, callback) {
    var $this = $(this);

    if (callback === undefined) {
        callback = selector;
        selector = undefined;
    }

    var handle = function (e) {
        if (e.currentTarget === e.target) {
            if (typeof callback === 'function') {
                callback.apply(this, arguments);
            }
        }
    };

    if (selector) {
        $this.on('animationend', selector, handle);
    } else {
        $this.on('animationend', handle);
    }
};

$.fn.cssAnimation = function (class_name) {
    $(this).each(function () {
        var $element = $(this);
        var data = {
            current_animation_class: null
        };

        var handleAnimationEnd = function (e) {
            if (e.target !== e.currentTarget) {
                return;
            }

            var data = $element.data('elkitorg_animation');
            $element.removeClass(data.current_animation_class);
            $element.removeClass(data.animation_class);
        };

        $element.on('animationend', handleAnimationEnd);

        data.animation_class = class_name;

        $element.data('elkitorg_animation', data);
    });
};

$.fn.runCssAnimation = function (animation_class_name) {
    $(this).each(function () {
        var $element = $(this);
        var data = $element.data('elkitorg_animation');

        if (!data) {
            return;
        }

        if (data.current_animation_class) {
            $element.removeClass(data.current_animation_class);
        }

        data.current_animation_class = animation_class_name;
        $element.addClass(data.animation_class);
        //$element.offset();
        $element.addClass(data.current_animation_class);

        $element.data('elkitorg_animation', data);
    });
};

$.datepicker.dpDiv.addClass('datepicker-bs');

$.datepicker.regional.ru = {
    closeText: 'Закрыть',
    prevText: '&#x3C;Пред',
    nextText: 'След&#x3E;',
    currentText: 'Сегодня',
    monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
        'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
    monthNamesShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн',
        'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
    dayNames: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'],
    dayNamesShort: ['вск', 'пнд', 'втр', 'срд', 'чтв', 'птн', 'сбт'],
    dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    weekHeader: 'Нед',
    dateFormat: 'dd.mm.yy',
    firstDay: 1,
    isRTL: false,
    showMonthAfterYear: false,
    yearSuffix: ''
};

$.datepicker.setDefaults($.datepicker.regional.ru);
